package com.gloopgo.game.ui

import com.gloopgo.game.engine.GameConstants

/**
 * Platform and environment metadata for display in settings and diagnostics.
 */
data class AppPlatformInfo(
    val appVersion: String = GameConstants.APP_VERSION,
    val isWeb: Boolean = false,
    val webOsName: String? = null
)

/**
 * Multiplatform expect function to retrieve current app version and platform environment.
 */
expect fun getAppPlatformInfo(): AppPlatformInfo
